import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import styles from "./Finbox.module.scss";

import Loader from "../../components/Loader/Loader";
import FinboxAPI from "../../services/finbox.api";
import CustomButton from "../../components/Button/CustomButton";
import { setStepperDisable } from "../../redux/slices/userSlice";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";
import { googleEvent_LOJ227, googleEvent_LOJ228 } from "../../lib/google-analytics";

export default function Finbox() {
  const [finboxError, setFinboxError] = useState(false);
  const [processingCount, setProcessingCount] = useState(0);

  const [apiStatus, setApiStatus] = useState("");

  const { upgradeLoanAmount } = useSelector((state) => state.user);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { finboxBankConnectAPI, bankingSurrogateAPI } = new FinboxAPI();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    const url = queryParams.get("url");
    const success = queryParams.get("success");
    const entity_id = queryParams.get("entity_id");

    if (url) {
      window.location.href = url;
    } else if (success === "true" && entity_id) {
      handlefinboxBankConnectAPI(entity_id);
      // setEntityID(entity_id);
    } else if (success === "false") {
      setFinboxError(true);
      dispatch(setStepperDisable(true));
    }
  }, [location.search]);

  useEffect(() => {
    handleCallAgain();
  }, [processingCount]);

  useEffect(() => {
    !finboxError ? handleShowContextualLoader("Please wait...") : handlehideContextualLoader();
    return () => {
      handlehideContextualLoader();
    };
  }, [finboxError]);

  const handleCallAgain = () => {
    dispatch(setStepperDisable(false));
    setTimeout(() => {
      const queryParams = new URLSearchParams(location.search);
      const entity_id = queryParams.get("entity_id");

      if (apiStatus === "processing") {
        handlefinboxBankConnectAPI(entity_id);
      }
    }, 2000);
  };

  const handlefinboxBankConnectAPI = async (entity_id) => {
    const res = await finboxBankConnectAPI(entity_id);

    if (res) {
      if (res.data.statusCode === 400) {
        dispatch(setStepperDisable(true));
        return;
      }

      if (Object.keys(res.data).length > 0) {
        if (res.data.api_status === "processing") {
          console.log("status-----------", res.data.api_status);
          setApiStatus(res.data.api_status);

          if (processingCount < 4) {
            setProcessingCount((prev) => prev + 1);
            console.log("count---------", processingCount);
          } else {
            googleEvent_LOJ227();
            switch (res.data.pageName) {
              case "approval":
                window.location.href = "/select-loan";
                break;
              case "dashboard":
                window.location.href = "/dashboard";
                break;
              case "rejected":
                window.location.href = "/loan-reject";
                break;
              default:
                window.location.href = "/dashboard";
                break;
            }
          }
        } else {
          // check loan amount upgrade
          if (upgradeLoanAmount) {
            handleBankingSurrogateAPI();
          } else {
            switch (res.data.pageName) {
              case "approval":
                window.location.href = "/select-loan";
                break;
              case "dashboard":
                window.location.href = "/dashboard";
                break;
              case "rejected":
                window.location.href = "/loan-reject";
                break;
              default:
                window.location.href = "/dashboard";
                break;
            }
          }
        }
      }
    } else {
      setFinboxError(true);
      googleEvent_LOJ228();
    }
  };

  const handleBankingSurrogateAPI = async () => {
    const res = await bankingSurrogateAPI();
    if (res) {
      if (res?.data?.data?.final_result_from_BRE === "REJECT") {
        window.location.href = '/dashboard';
      } if(res?.data?.pageName?.toLowerCase() === "rejected") {
        window.location.href = '/loan-reject';
      } else {
        window.location.href = '/select-loan';
      }
    }
  };

  return (
    <div className="wrapper">
      {finboxError && (
        <div className={styles.finbox__error}>
          <img src="/images/alert.png" alt="" />
          <h3>Oops!</h3>
          <p>
            We are unable to fetch <br /> your bank account
          </p>

          <CustomButton
            text="Go Back"
            onClick={() => {
              // window.location.href = "/dashboard";
              navigate("/home");
            }}
          />
        </div>
      )}
    </div>
  );
}
